import { useState } from 'react';
import { CIVIL3D_VIEWS } from '../content/visuals';

const MODES = ['rgb', 'depth', 'cloud', 'mesh'];

export default function CivilWorkspace() {
  const [mode, setMode] = useState('cloud');
  const [split, setSplit] = useState(52);
  const overlay = CIVIL3D_VIEWS[mode] || CIVIL3D_VIEWS.cloud;
  const comparing = mode !== 'rgb';

  return (
    <figure className="bv-workspace">
      <div className="bv-workspace-stage">
        <img
          src={CIVIL3D_VIEWS.rgb.src}
          srcSet={CIVIL3D_VIEWS.rgb.srcSet}
          sizes="(max-width: 900px) 88vw, 520px"
          alt={CIVIL3D_VIEWS.rgb.alt}
          width="720"
          height="537"
        />
        {comparing && (
          <div
            className="bv-workspace-overlay"
            style={{ clipPath: `inset(0 0 0 ${split}%)` }}
          >
            <img
              src={overlay.src}
              srcSet={overlay.srcSet}
              sizes="(max-width: 900px) 88vw, 520px"
              alt=""
              width="720"
              height="537"
            />
          </div>
        )}
        <label className="bv-workspace-slider">
          <span className="sr-only">Compare RGB with {overlay.label}</span>
          <input
            type="range"
            min="8"
            max="92"
            value={comparing ? split : 100}
            disabled={!comparing}
            onChange={(event) => setSplit(Number(event.target.value))}
          />
          <span>
            <b>RGB</b>
            <i />
            <b>{overlay.label}</b>
          </span>
        </label>
      </div>

      <div className="bv-workspace-thumbs" role="tablist" aria-label="Reconstruction views">
        {MODES.map((id) => {
          const view = CIVIL3D_VIEWS[id];
          const selected = mode === id;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={selected}
              className={selected ? 'is-active' : undefined}
              onClick={() => setMode(id)}
            >
              <img src={view.src} alt="" width="140" height="104" />
              <span>{view.label}</span>
            </button>
          );
        })}
      </div>
    </figure>
  );
}
